import {BaseService} from "./base.service";

class SinisterService extends BaseService {

    constructor() {
        super('api/sinister')
    }

    printSinister(id) {
        return this.http.post(`api/print-sinister/${id}`).then(response => response.data).catch(err => err.message);
    }

    authServ(id) {
        return this.http.get(`api/auth-extra-service/${id}`).then(response => response.data).catch(err => err.message);
    }

    getSinisterCollection(params) {
        return this.http.post(`api/sinister-providers-collection`, params).then(response => response.data).catch(err => err.message);
    }


}

export const sinisterService = new SinisterService();
